import { ReactNode, useLayoutEffect } from 'react';

import { useCustomMediaQuery } from '@libs/hooks/useCustomMediaQuery';

import { Device, MediaQueryContext } from './MediaQueryContext';

const MEDIA_QUERIES: Record<Device, string> = {
  desktop: '(min-width: 1024px)',
  tablet: '(max-width: 1023px) and (min-width: 820px)',
  mobile: '(max-width: 819px)',
};

export function MediaQueryProvider({
  children,
  mediaQueries = MEDIA_QUERIES,
}: {
  children: ReactNode;
  /** ВАЖНО: media queries должны быть взаимоисключающими */
  mediaQueries?: Record<Device, string>;
}) {
  const device = useCustomMediaQuery(mediaQueries, 'desktop');

  useLayoutEffect(() => {
    const body = getBody();
    body.classList.remove(...Object.keys(mediaQueries));
    body.classList.add(device);
  }, [mediaQueries, device]);

  return <MediaQueryContext.Provider value={device}>{children}</MediaQueryContext.Provider>;
}

// HACK: чтобы классы работали в iframe ladle (наш сторибук)
function getBody() {
  if (process.env.NODE_ENV !== 'production') {
    const framedBody =
      document.querySelector<HTMLIFrameElement>('.ladle-iframe')?.contentDocument?.body;
    if (framedBody) return framedBody;
  }

  return document.body;
}
